// this is an autogenerated file from App/Account/Content/Marketing/LeadsConfigurationChooser/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Marketing_LeadsConfigurationChooser_Content{
  configurations: leads_configurations(where: { active: { _eq: true } }) {
    id
    name
    organization {
      id
      _id
      name
      level
      parent_company {
        id
        name
        level
      }
      parent {
        id
        name
        level
      }
    }
  }
}

`